import { classes } from 'html-classes';
import { observer } from 'mobx-react-lite';
import type { ReactNode } from 'react';
import { useTranslation } from 'react-i18next';
import { Link } from 'react-router-dom';

import CloudflareResponseImage from '~/components/CloudflareResponsiveImage/CloudflareResponseImage';
import { defaultSrcSetParams } from '~/components/CloudflareResponsiveImage/constants';
import { CommonCarousel } from '~/components/CommonCarousel';
import { useCategoryAnalytics } from '~/hooks/useCategoryAnalytics';
import styles from '~/pages/Checkout/CheckoutContent.module.scss';
import { cartStore, checkoutStore, orderStore } from '~/stores';
import { isProductBundle } from '~/types/Product';

const PickUpProductList = ({ className }: { className?: string }) => {
  const { handleClickProduct } = useCategoryAnalytics();
  const { t } = useTranslation();

  const range = orderStore.etaCalculation?.duration.range ?? '5 - 10';

  return (
    <div className={classes([styles.pickupContentWr, className])}>
      <h3 className={styles.pickupContent__title}>
        {t('deliveryMethods:yourOrderWillBeReady', {
          range,
        })}
      </h3>

      <div className={styles.pickupContent__products}>
        <CommonCarousel
          slideClassName={styles.pickupContent__products__item}
          containerClassName={styles.pickupContent__products__container}
          spaceBetween={8}
          slidesPerViewProp="auto"
          arrows={false}
          freeMode={true}
        >
          {
            checkoutStore.deliveries
              ?.map((item) => item.itemsIds)
              .flat()
              .map((cartItemId) => {
                const item = cartStore.selectedCartItems.find(
                  (item) => item.sku === cartItemId,
                );

                if (!item) {
                  return;
                }

                return (
                  <Link
                    key={item.id}
                    onClick={handleClickProduct(item)}
                    to={
                      `/p/${item.slug}` +
                      (isProductBundle(item) ? '' : `?sku=${item.sku}`)
                    }
                    state={{
                      ...(isProductBundle(item) ? {} : { offerSku: item.sku }),
                    }}
                  >
                    <div
                      key={item.previewImageThumb}
                      className="slot-list__slot-images-item"
                    >
                      <CloudflareResponseImage
                        src={item.previewImageThumb}
                        srcParams={{ width: 50, height: 72 }}
                        srcSetParams={defaultSrcSetParams}
                        alt={item.name}
                        loading="lazy"
                      />
                    </div>
                  </Link>
                );
              })
              .filter(Boolean) as ReactNode[]
          }
        </CommonCarousel>
      </div>
    </div>
  );
};

export default observer(PickUpProductList);
